import { useState } from 'react';
import {
  Route, Routes, useLocation, useNavigate,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MainPage from './main/MainPage';
import CombinedReportPage from './reports/CombinedReportPage';
import RouteReportPage from './reports/RouteReportPage';
import ServerPage from './settings/ServerPage';
import UsersPage from './settings/UsersPage';
import DevicePage from './settings/DevicePage';
import UserPage from './settings/UserPage';
import NotificationsPage from './settings/NotificationsPage';
import NotificationPage from './settings/NotificationPage';
import GroupsPage from './settings/GroupsPage';
import GroupPage from './settings/GroupPage';
import PositionPage from './other/PositionPage';
import NetworkPage from './other/NetworkPage';
import EventReportPage from './reports/EventReportPage';
import ReplayPage from './other/ReplayPage';
import TripReportPage from './reports/TripReportPage';
import StopReportPage from './reports/StopReportPage';
import SummaryReportPage from './reports/SummaryReportPage';
import ChartReportPage from './reports/ChartReportPage';
import DriversPage from './settings/DriversPage';
import DriverPage from './settings/DriverPage';
import CalendarsPage from './settings/CalendarsPage';
import CalendarPage from './settings/CalendarPage';
import ComputedAttributesPage from './settings/ComputedAttributesPage';
import ComputedAttributePage from './settings/ComputedAttributePage';
import MaintenancesPage from './settings/MaintenancesPage';
import MaintenancePage from './settings/MaintenancePage';
import CommandsPage from './settings/CommandsPage';
import CommandPage from './settings/CommandPage';
import StatisticsPage from './reports/StatisticsPage';
import LoginPage from './login/LoginPage';
import RegisterPage from './login/RegisterPage';
import ResetPasswordPage from './login/ResetPasswordPage';
import GeofencesPage from './other/GeofencesPage';
import GeofencePage from './settings/GeofencePage';
import useQuery from './common/util/useQuery';
import { useEffectAsync } from './reactHelper';
import { devicesActions } from './store';
import EventPage from './other/EventPage';
import PreferencesPage from './settings/PreferencesPage';
import AccumulatorsPage from './settings/AccumulatorsPage';
import CommandDevicePage from './settings/CommandDevicePage';
import CommandGroupPage from './settings/CommandGroupPage';
import App from './App';
import ChangeServerPage from './login/ChangeServerPage';
import DevicesPage from './settings/DevicesPage';
import ScheduledPage from './reports/ScheduledPage';
import DeviceConnectionsPage from './settings/DeviceConnectionsPage';
import GroupConnectionsPage from './settings/GroupConnectionsPage';
import UserConnectionsPage from './settings/UserConnectionsPage';
import LogsPage from './reports/LogsPage';
import SharePage from './settings/SharePage';
import AnnouncementPage from './settings/AnnouncementPage';
import EmulatorPage from './other/EmulatorPage';
import Loader from './common/components/Loader';
import { generateLoginToken } from './common/components/NativeInterface';
import { useLocalization } from './common/components/LocalizationProvider';
import fetchOrThrow from './common/util/fetchOrThrow';
/** MOD */
import UpdatesPage from './settings/UpdatesPage';
import DashboardPage from './settings/DashboardPage';
//import TelaLogs from './main/logs';
import RevendasPage from "./settings/RevendasPage";
import RevendaPage from "./settings/RevendaPage";
import WhatsappPage from "./settings/WhatsappPage";
// import InstallationPage from "./settings/InstallationPage";
// import InstallationsPage from "./settings/InstallationsPage";
import CostPage from "./settings/CostPage";
import CostsPage from "./settings/CostsPage";
import DevicesReportPage from "./reports/DevicesReportPage";
import GeofencesReportPage from "./reports/GeofencesReportPage";
import CommandsReportPage from "./reports/CommandsReportPage";
import CostsReportPage from "./reports/CostsReportPage";
import CostsResumeReportPage from "./reports/CostsResumeReportPage";
import ActionsReportPage from "./reports/ActionsReportPage";
import Dash2 from './main/dash2';
import Dash3 from './main/dash3';

const Navigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setLanguage } = useLocalization();

  const [redirectsHandled, setRedirectsHandled] = useState(false);

  const { pathname } = useLocation();
  const query = useQuery();

  useEffectAsync(async () => {
    if (query.get('locale')) {
      setLanguage(query.get('locale'));
    }
    if (query.get('token')) {
      const token = query.get('token');
      await fetch(`/api/session?token=${encodeURIComponent(token)}`);
      navigate(pathname);
    } else if (query.get('deviceId')) {
      const deviceId = query.get('deviceId');
      const response = await fetchOrThrow(`/api/devices?uniqueId=${deviceId}`);
      const items = await response.json();
      if (items.length > 0) {
        dispatch(devicesActions.selectId(items[0].id));
      }
      navigate('/');
    } else if (query.get('eventId')) {
      const eventId = parseInt(query.get('eventId'), 10);
      navigate(`/event/${eventId}`);
    } else if (query.get('openid')) {
      if (query.get('openid') === 'success') {
        generateLoginToken();
      }
      navigate('/');
    } else {
      setRedirectsHandled(true);
    }
  }, [query]);

  if (!redirectsHandled) {
    return (<Loader />);
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/change-server" element={<ChangeServerPage />} />
      <Route path="/" element={<App />}>
        <Route index element={<MainPage />} />

        <Route path="position/:id" element={<PositionPage />} />
        <Route path="network/:positionId" element={<NetworkPage />} />
        <Route path="event/:id" element={<EventPage />} />
        <Route path="replay" element={<ReplayPage />} />
        <Route path="geofences" element={<GeofencesPage />} />
        <Route path="emulator" element={<EmulatorPage />} />
      <Route path="/dash2" element={<Dash2 />} />
      <Route path="/dash3" element={<Dash3 />} />
      <Route path="revendas" element={<RevendasPage />} />
      <Route path="costs" element={<CostsPage />} />
      <Route path="/CostsReportPage" element={<CostsReportPage />} />
      <Route path="/CostsResumeReportPage" element={<CostsResumeReportPage />} />
      <Route path="/ActionsReportPage" element={<ActionsReportPage />} />




        <Route path="settings">
          <Route path="accumulators/:deviceId" element={<AccumulatorsPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="announcement" element={<AnnouncementPage />} />
          <Route path="calendars" element={<CalendarsPage />} />
          <Route path="calendar/:id" element={<CalendarPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="commands" element={<CommandsPage />} />
          <Route path="command/:id" element={<CommandPage />} />
          <Route path="command" element={<CommandPage />} />
          <Route path="attributes" element={<ComputedAttributesPage />} />
          <Route path="attribute/:id" element={<ComputedAttributePage />} />
          <Route path="attribute" element={<ComputedAttributePage />} />
          <Route path="devices" element={<DevicesPage />} />
          <Route path="device/:id/connections" element={<DeviceConnectionsPage />} />
          <Route path="device/:id/command" element={<CommandDevicePage />} />
          <Route path="device/:id/share" element={<SharePage />} />
          <Route path="device/:id" element={<DevicePage />} />
          <Route path="command-send/:deviceId" element={<CommandsPage />} />
          <Route path="device" element={<DevicePage />} />
          <Route path="drivers" element={<DriversPage />} />
          <Route path="driver/:id" element={<DriverPage />} />
          <Route path="driver" element={<DriverPage />} />
          <Route path="geofence/:id" element={<GeofencePage />} />
          <Route path="geofence" element={<GeofencePage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="group/:id/connections" element={<GroupConnectionsPage />} />
          <Route path="group/:id/command" element={<CommandGroupPage />} />
          <Route path="group/:id" element={<GroupPage />} />
          <Route path="group" element={<GroupPage />} />
          <Route path="maintenances" element={<MaintenancesPage />} />
          <Route path="maintenance/:id" element={<MaintenancePage />} />
          <Route path="maintenance" element={<MaintenancePage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="notification/:id" element={<NotificationPage />} />
          <Route path="notification" element={<NotificationPage />} />
          <Route path="preferences" element={<PreferencesPage />} />
          <Route path="server" element={<ServerPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="user/:id/connections" element={<UserConnectionsPage />} />
          <Route path="user/:id" element={<UserPage />} />
          <Route path="user" element={<UserPage />} />
          {/* MODS */}
{/*           <Route path="updates" element={<UpdatesPage />} /> */}
{/*           <Route path="billings" element={<BillingsPage />} /> */}
{/*           <Route path="billing/:id" element={<BillingPage />} /> */}
{/*           <Route path="billing" element={<BillingPage />} /> */}
{/*           <Route path="plans" element={<PlansPage />} /> */}
{/*           <Route path="plan/:id" element={<PlanPage />} /> */}
{/*           <Route path="plan" element={<PlanPage />} /> */}
{/*           <Route path="contracts" element={<ContractsPage />} /> */}
{/*           <Route path="contract/:id" element={<ContractPage />} /> */}
{/*           <Route path="contract" element={<ContractPage />} /> */}
{/*           <Route path="invoices" element={<InvoicesPage />} /> */}
{/*           <Route path="invoice/:id" element={<InvoicePage />} /> */}
{/*           <Route path="invoice" element={<InvoicePage />} /> */}
{/*           <Route path="installations" element={<InstallationsPage />} /> */}
{/*           <Route path="installation/:id" element={<InstallationPage />} /> */}
{/*           <Route path="installation" element={<InstallationPage />} />           */}
          <Route path="revendas" element={<RevendasPage />} />
          <Route path="revenda/:id" element={<RevendaPage />} />
          <Route path="revenda" element={<RevendaPage />} />
          <Route path="whatsapp" element={<WhatsappPage />} />
          <Route path="costs" element={<CostsPage />} />
          <Route path="cost/:id" element={<CostPage />} />
          <Route path="cost" element={<CostPage />} />
        </Route>

        <Route path="reports">
          <Route path="combined" element={<CombinedReportPage />} />
          <Route path="chart" element={<ChartReportPage />} />
          <Route path="event" element={<EventReportPage />} />
          <Route path="route" element={<RouteReportPage />} />
          <Route path="stop" element={<StopReportPage />} />
          <Route path="summary" element={<SummaryReportPage />} />
          <Route path="trip" element={<TripReportPage />} />
          <Route path="scheduled" element={<ScheduledPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="logs" element={<LogsPage />} />
          {/* MOD */}
          <Route path="actions" element={<ActionsReportPage />} />
          <Route path="devices" element={<DevicesReportPage />} />
          <Route path="commands" element={<CommandsReportPage />} />
          <Route path="geofences" element={<GeofencesReportPage />} />
          <Route path="costs" element={<CostsReportPage />} />
          <Route path="costsresume" element={<CostsResumeReportPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Navigation;
